import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function lotteryRouteI18n(): string {
  return (appRoutesI18nCache['lottery'] ??= $localize`:url-segment@@lottery-url-segment:lottery`);
}
